import { Text } from "ui/Typography"
import useSummaryDetails from "../../hooks/useSummaryDetails"
import PropTypes from "prop-types"
import { Divider, Flex } from "antd"
import { spacings } from "themes/variables"
import { useTranslation } from "react-i18next"
import SummaryKeyValue from "../../SummaryKeyValue"
import moment from "moment"

const UpdatedPriceDetailsItem = ({ history }) => {
  const { t } = useTranslation()
  const { id, payment_summary: paymentSummary, created_at: createdAt, payment_history } = history || {}
  const summaryDetails = useSummaryDetails(paymentSummary)
  const { total_price = 0, remaining_balance = 0 } = paymentSummary ?? {}
  const paymentHistory = payment_history?.find((item) => item)

  const detailsWithTotals = [
    ...summaryDetails,
    { labelKey: "client.client_booking.total", value: total_price, fw: 700 },
    ...(paymentHistory?.amount
      ? [
          {
            label: (() => {
              const parts = [paymentHistory?.type];
              const method = paymentHistory?.method;
              const last4 = paymentHistory?.last4;
              
              if (method || last4) {
                const paymentInfo = [];
                if (method) paymentInfo.push(method);
                if (last4) paymentInfo.push(`••••${last4}`);
                parts.push(`(${paymentInfo.join(' ')})`);
              }
              
              return parts.filter(Boolean).join(' ').trim();
            })(),
            value: paymentHistory?.amount
          }
        ]
      : []),
    { labelKey: "client.payment.labels.remaining_balance", value: remaining_balance, fw: 700 }
  ]

  const dateTime = createdAt ? moment(createdAt).local().format("MM/DD/YYYY hh:mm A") : ""

  return (
    <Flex key={id || createdAt} vertical gap={spacings.XS}>
      <Text fw={500} size="lg">
        {t("client.payment.labels.updated_price_details", { dateTime })}
      </Text>
      <SummaryKeyValue details={detailsWithTotals} valueAlign="right" />
    </Flex>
  )
}

UpdatedPriceDetailsItem.propTypes = {
  history: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    created_at: PropTypes.string,
    payment_summary: PropTypes.object
  })
}

const UpdatedPriceDetails = ({ priceChangeHistories }) => {
  if (!Array.isArray(priceChangeHistories) || !priceChangeHistories?.length) return null

  return (
    <Flex vertical gap={spacings.S} className="px-xl py-s">
      {priceChangeHistories.map((history) => (
        <>
          <UpdatedPriceDetailsItem key={history?.id || history?.created_at} history={history} />
          <Divider size="small" className="m-0" />
        </>
      ))}
    </Flex>
  )
}

UpdatedPriceDetails.propTypes = {
  priceChangeHistories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      created_at: PropTypes.string,
      payment_summary: PropTypes.object
    })
  )
}

export default UpdatedPriceDetails
